<script>
    import main from '../../state/main';

    const paymentPage =  `${$main.baseWeb}/platba-online`;
    let menu = [
        {
            caption: 'Obchodní podmínky',
            url: `${$main.baseWeb}/vop`,
        },
        {
            caption: 'Ceník',
            url: `${$main.baseWeb}/cenik`,
        },
        {
            caption: 'Platba online',
            url: paymentPage,
        },
    ];

    let logos = [
        {
            size: 32,
            name: 'comgate.svg',
            alt: 'ComGate',
        },
        {
            name: 'visa.svg',
            alt: 'VISA',
        },
        {
            size: 24,
            name: 'mastercard.svg',
            alt: 'Mastercard',
        },
    ];
</script>

<style>
    footer {
        padding: 30px;
        background: #e8eef4;
        color: #7c8081;
    }

    .contents {
        display: grid;
        grid-template-columns: auto 1fr;
        grid-template-rows: auto 1fr;
        margin: 0 auto;
        max-width: 600px;
        gap: 8px 30px;
    }

    .contents > .contact {
        grid-row: 1 / span 2;
        font-size: 14px;
        margin-right: auto;
    }

    @media (max-width: 599px) {
        .contents {
            display: grid;
            grid-template-columns: 100%;
            row-gap: 16px;
        }

        .contents > .contact {
            grid-row: auto;
        }
    }

    @media (min-width: 600px) {
        .contents > .menu, .contents > .gate {
            justify-self: end;
        }
    }

    .contents > .contact > .item:first-child {
        font-weight: 600;
        font-size: 16px;
    }

    .contents > .menu {
        display: flex;
        flex-flow: row wrap;
        gap: 16px;
    }

    .contents > .menu > a {
        /* padding: 0 6px; */
        font-weight: 600;
        text-decoration: none;
        border-bottom: 1px solid;
    }

    .contents > .menu > a:hover {
        border-bottom-color: transparent;
    }

    .contents > .gate {
        display: flex;
        flex-flow: row wrap;
        gap: 8px 16px;
        align-items: center;
        /* margin-top: auto; */
    }
</style>

<footer>
    <div class="contents">
        <div class="contact">
            <div class="item">Linda Varnušková</div>
            <div class="item">Telefon: <a href="tel:+420723773360">+420 723 773 360</a></div>
            <div class="item">Email: <a href="mailto:chytrypohyb@email.cz">chytrypohyb@email.cz</a></div>
            <div class="item">Sídlo: Svojsíkova 1245/21, Liberec</div>
            <div class="item">IČ: 76384942</div>
        </div>

        <div class="menu">
            {#each menu as item}
                <a href="{item.url}">{item.caption}</a>
            {/each}
        </div>

        <a class="gate" href="{paymentPage}">
            {#each logos as logo}
                <img src="/gate/{logo.name}" alt="{logo.alt}" draggable="false" style="height: {logo.size ?? 20}px">
            {/each}
        </a>
    </div>
</footer>
